import constants from './constants';

const initialState = {
    loading: false,
    response: null,
    error: null
};


export const orderIdCardReducer = (state = initialState ,action)=> {
    switch(action.type){
        case constants.ORDER_ID_CARD_BEGIN: return {...state , loading: true, error: null};
        case constants.ORDER_ID_CARD_SUCCESS: return {...state , loading: false, response: action.payload.data};
        case constants.ORDER_ID_CARD_ERROR: return {...state , loading : false, error: action.payload.error};
        case constants.ORDER_ID_CARD_CLEANUP: return initialState;
        default: return state;
    }
};